import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { toggleEnabledGantt } from '../effects/toggleEnabledGantt';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import {
    getProFeaturesTrialActive
} from '../../../../../../../../../store/model/authUser/selectors/getProFeaturesTrialActive';
import {
    authUserSetUsedProFeatures
} from '../../../../../../../../../rest/effects/authUser/authUserSetUsedProFeatures';

export const onChange = (
    boardId: TBoardId
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        if (getProFeaturesTrialActive(getState())) {
            dispatch(authUserSetUsedProFeatures('allowGantt'));
        }
        dispatch(toggleEnabledGantt(boardId));
    };
    return action;
};
